import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page79() {
  useEffect(() => {
    document.title = "Маяк — Страница 78"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page77" />
        <ForwardLink href="/page79" />
      </div>

      <p style={{ textAlign: "right" }}>78.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я доложу <i>о тебе.</i> Я знаю, что ты<br/>
        сделал...
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Кто доложит, кто?<br/>
        <br/>
        Эфраим Уинслоу?<br/>
        <br/>
        Или Томас Ховард?<br/>
        <br/>
        Я знаю, что <u>ты</u> сделал--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        (неожиданно)<br/>
        Ты убил своего напарника.
      </p>
      <p>МОЛОДОЙ УЛЫБАЕТСЯ.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        --
      </p>
      <p>На этот раз СТАРИК потерял дар речи. В ужасе.</p>
      <p>МОЛОДОЙ счастлив, насколько это возможно. Сумасшедший. Маниакальный.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я нашел его. Одноглазого<br/>
        юношу.<br/>
        <br/>
        В ловушке для омаров.<br/>
        <br/>
        Он сошел с ума? Ты довел его своими<br/>
        чарами! Эта безделушка,<br/>
        это морское заклинание, которое держало его подальше<br/>
        от твоей тайны... Но я разгадал ее, видишь.<br/>
        Я свободен.
      </p>
      <p>
        МОЛОДОЙ неуклюже рыщет в карманах и находит<br/>
        обломки РУСАЛКИ ИЗ СЛОНОВОЙ КОСТИ. Он бросает ее к ногам<br/>
        СТАРИКА! Молодой торжествующе улыбается и исполняет праздничную джигу!
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Свободен от твоих козней!
      </p>
      <p>СТАРИК не выражает эмоций.</p>
      <p>МОЛОДОЙ прекращает танцевать джигу.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        И я во всем разобрался, за исключением<br/>
        того, что за зловещую тайну ты<br/>
        хранишь...
      </p>
      <p style={{ textAlign: "right" }}>78.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page77" />
        <ForwardLink href="/page79" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710635491/the-lighthouse-script/jeyqlmjsrrzh6djatphr.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page79;
